
<div class="new-password-container">
    <div class="new-password-content">
        <div class="new-password-title">New Password</div>
        <div class="new-password-subtitle">Password must be between 8 and 20 characters and contain at least one capital letter, one number and one symbol.</div>

        <div class="input-group">
            <app-custom-text-field [placeholder]="'Enter new password'" [type]="'email'" [height]="48" [width]="354"></app-custom-text-field>
            <app-custom-text-field [placeholder]="'Verify new password'" [type]="'email'" [height]="48" [width]="354"></app-custom-text-field>
        </div>

        <div class="button-container">
            <app-button [displayText]="'Submit'" type="secondary" [height]="48" [width]="356" (clicked)="setNewPassword()"></app-button>
            <app-button [displayText]="'Cancel'" type="default" [showBorder]="false" [height]="48" [width]="356" (clicked)="cancel()"></app-button>
        </div>
    </div>
</div>